import { render } from "./wzselect.vue?vue&type=template&id=5680cb74&scoped=true"
import script from "./wzselect.vue?vue&type=script&lang=js"
export * from "./wzselect.vue?vue&type=script&lang=js"

import "./wzselect.vue?vue&type=style&index=0&id=5680cb74&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5680cb74"]])

export default __exports__